import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useProduto } from '../../hooks/useProduto';
import { Form } from './Form';
import { ButtonNavigation, ButtonSeparator } from './styles';
import { TableAssociado } from './TableAssociado';
import { InputAsyncSelect } from '~/components/NovosInputs';
import Separator from '~/components/Separator';
import { AiOutlinePlusCircle } from 'react-icons/ai';
import { ModalDerivado } from './ModalDerivado';
import { TableDerivados } from './TableDerivados';
import { FormDerivados } from './FormDerivados';

const AbaEquivalentes: React.FC = () => {
  const {
    setValue,
    register,
    control,
    formState: { errors },
    watch,
    resetDerivado,
    hasVariacaoGrade,
    openModalDerivado,
    handleOpenModalDerivado,
    selectDerivado,
    handleChangeSelectDerivado,
    verifyIfIsDerivado,
    handleChangeAssoc,
  } = useProduto();

  useEffect(() => {
    if (hasVariacaoGrade) handleChangeAssoc(0);
  }, [hasVariacaoGrade]);

  return (
    <>
      <Row>
        <Col sm={12} md={12} lg={12} xl={12}>
          <InputAsyncSelect
            label="Similares (Preço)"
            maxLength={50}
            placeholder="Nenhum Similar Selecionado"
            name="cod_similar"
            register={register}
            isError={!!errors.cod_similar}
            control={control}
            includeNoneOption
            changeSelected={(selected: any) => {
              selected.value = selected.cod_similar || selected.value;
              setValue('cod_similar', {
                value: selected.value,
                label: selected.label,
              });
            }}
            api={{
              route: '/produto/similar',
              method: 'get',
              fields: ['des_similar'],
              searchBeforeFilter: true,
            }}
            disabled={hasVariacaoGrade}
          />
        </Col>
        <Col sm={12} md={12} lg={12} xl={12}>
          <InputAsyncSelect
            label="Marca"
            maxLength={50}
            placeholder="Nenhuma Marca Selecionada"
            name="cod_marca"
            register={register}
            isError={!!errors.cod_marca}
            control={control}
            includeNoneOption
            changeSelected={(selected: any) => {
              selected.value = selected.cod_marca || selected.value;
              setValue('cod_marca', {
                value: selected.value,
                label: selected.label,
              });
            }}
            api={{
              route: '/produto/marcas',
              method: 'get',
              fields: ['des_marca'],
              searchBeforeFilter: true,
            }}
          />
        </Col>
      </Row>

      <Row className="mt-4 mb-4">
        <Col md={7} sm={12}>
          <Separator labelText="Associado (Estoque)" childrenWidth="160px" />
        </Col>
        <Col
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
          md={5}
          sm={12}
        >
          <ButtonNavigation
            type="button"
            className="btnNewDataGrid"
            style={{
              backgroundColor:
                watch('tipo_associado') === 0 ? '#8850BF' : 'transparent',
              color: watch('tipo_associado') === 0 ? '#fff' : '#6B778C',
            }}
            onClick={() => handleChangeAssoc(0)}
          >
            Independente
          </ButtonNavigation>

          <ButtonSeparator />

          <ButtonNavigation
            type="button"
            className="btnNewDataGrid"
            onClick={() => handleChangeAssoc(1)}
            style={{
              padding: '5px 10px',
              backgroundColor:
                watch('tipo_associado') === 1 ? '#8850BF' : 'transparent',
              color: watch('tipo_associado') === 1 ? '#fff' : '#6B778C',
              cursor: hasVariacaoGrade ? 'not-allowed' : 'pointer',
            }}
            disabled={hasVariacaoGrade}
          >
            Incluir Pai
          </ButtonNavigation>

          <ButtonSeparator />

          <ButtonNavigation
            type="button"
            className="btnNewDataGrid"
            style={{
              backgroundColor:
                watch('tipo_associado') === 2 ? '#8850BF' : 'transparent',
              color: watch('tipo_associado') === 2 ? '#fff' : '#6B778C',
              cursor: hasVariacaoGrade ? 'not-allowed' : 'pointer',
            }}
            onClick={() => handleChangeAssoc(2)}
            disabled={hasVariacaoGrade}
          >
            Incluir Filhos
          </ButtonNavigation>
        </Col>
      </Row>

      {watch('tipo_associado') !== 0 && (
        <>
          <Form />
          <TableAssociado />
        </>
      )}

      <Row className="mt-4 mb-4">
        <Col sm={12}>
          <Separator labelText="Insumos Derivados" childrenWidth="300px">
            <div
              style={{
                display: 'flex',
                gap: '10px',
                justifyContent: 'flex-end',
              }}
            >
              <button
                type="button"
                onClick={async () => {
                  const isDerivado = await verifyIfIsDerivado();
                  if (isDerivado) return;
                  handleChangeSelectDerivado(!selectDerivado);
                }}
                style={{
                  padding: '8px',
                  backgroundColor: 'transparent',
                  border: 'none',
                  borderRadius: '5px',
                  transition: '0.4s',
                  color: '#424242',
                  marginTop: '-7px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                }}
              >
                <AiOutlinePlusCircle size={16} style={{ color: 'green' }} />
                Incluir Derivado
              </button>

              <button
                type="button"
                onClick={() => {
                  resetDerivado({
                    des_produto: '',
                    cod_departamento: '',
                    cod_tipo_ajuste: { label: undefined, value: undefined },
                  });
                  handleOpenModalDerivado(true);
                }}
                style={{
                  padding: '8px',
                  backgroundColor: 'transparent',
                  border: 'none',
                  borderRadius: '5px',
                  transition: '0.4s',
                  color: '#424242',
                  marginTop: '-7px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                }}
              >
                <AiOutlinePlusCircle size={16} style={{ color: 'green' }} />
                Criar Derivado
              </button>
            </div>
          </Separator>
        </Col>
        {selectDerivado && <FormDerivados />}
      </Row>

      <TableDerivados />

      {openModalDerivado && <ModalDerivado />}
    </>
  );
};
export default AbaEquivalentes;
